module.exports = __webpack_public_path__ + "static/media/bellicon.86a003bc.svg";